var $a516ff2265dc1cde$exports = {};
$a516ff2265dc1cde$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data`,
            other: `Datas`
        })} selecionada(s) indispon\xedvel(is).`
};


export {$a516ff2265dc1cde$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
